export default "__VITE_ASSET__CqN5lU8v__"